import * as React from 'react';

export function TextIcon({width = 10, height = 11, ...props}: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 10 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect
                x={0.25}
                y={0.75}
                width={9.5}
                height={9.5}
                rx={1.75}
                fill="currentColor"
                fillOpacity={0.1}
                stroke="currentColor"
                strokeWidth={0.5}
            />
            <path d="M5 8.5v-5m0 0H3.4a.4.4 0 00-.4.4V4m2-.5h1.8c.11 0 .2.09.2.2V4" stroke="currentColor" />
        </svg>
    );
}
